export const EventTypes = {
    notification: {
        shown: 'notification.shown',
        clicked: 'notification.clicked',
        markedAsRead: 'notification.marked_as_read',
        markedAsUnread: 'notification.marked_as_unread',
    },
    encourageSellerReply: {
        shown: 'encourage_seller_reply.shown',
        hovered: 'encourage_seller_reply.hovered',
        closed: 'encourage_seller_reply.closed',
        minimized: 'encourage_seller_reply.minimized',
        clickedOnBuyerName: 'encourage_seller_reply.clicked_on_buyer_name',
        clickedOnBubble: 'encourage_seller_reply.clicked_on_bubble',
        eligibleForExperience: 'encourage_seller_reply.eligible_for_experience',
    },
};
